//Here should be severity*10 to allow smooth coloring when sliding
const getSeverityColor = (severity, mode) => {
  return getProgressColor(severity * 10, mode);
};

const getProgressColor = (severityDec, mode) => {
  if (severityDec == undefined) {
    return 'rgb(255, 255, 255)';
  }
  var sRed;
  var sGreen;
  var sBlue;
  var eRed;
  var eGreen;
  var eBlue;

  if (mode === 'DailyReflection') {
    severityDec = 100 - severityDec;
  }

  if (severityDec < 50) {
    sRed = 0x52;
    sGreen = 0xc9;
    sBlue = 0x75;
    eRed = 0xe8;
    eGreen = 0xd1;
    eBlue = 0x21;
  } else {
    sRed = 0xe8;
    sGreen = 0xd1;
    sBlue = 0x21;
    eRed = 0xf8;
    eGreen = 0x64;
    eBlue = 0x06;
    severityDec = severityDec - 50;
  }

  var currentColor =
    'rgb(' +
    Math.round(sRed + ((eRed - sRed) / 50) * severityDec) +
    ',' +
    Math.round(sGreen + ((eGreen - sGreen) / 50) * severityDec) +
    ',' +
    Math.round(sBlue + ((eBlue - sBlue) / 50) * severityDec) +
    ')';
  return currentColor;
};

export { getSeverityColor, getProgressColor };
